import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../engine/HttpClientEngineCapability.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from '../request/ClientUpgradeContent.mjs';
import { isWebsocket1w1xog9vfgwm1 as isWebsocket } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { SSEClientContent14bbfeddoyr65 as SSEClientContent } from './sse/SSEClientContent.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance1oebf6ttzyqzk as Send_instance } from './api/CommonHooks.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { cancel1xim2hrvjmwpn as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return LOGGER;
}
var LOGGER;
function get_HttpTimeout() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return HttpTimeout;
}
var HttpTimeout;
var HttpTimeoutCapabilityClass;
function HttpTimeoutCapability() {
  if (HttpTimeoutCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'HttpTimeoutCapability';
      }
      hashCode() {
        return 2058496954;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpTimeoutCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability()]);
    HttpTimeoutCapabilityClass = $;
  }
  return HttpTimeoutCapabilityClass;
}
var HttpTimeoutCapability_instance;
function HttpTimeoutCapability_getInstance() {
  return HttpTimeoutCapability_instance;
}
var HttpRequestTimeoutExceptionClass;
function HttpRequestTimeoutException() {
  if (HttpRequestTimeoutExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(url, timeoutMillis, cause) {
        return new.target.c5v(url, timeoutMillis, cause);
      }
      static c5v(url, timeoutMillis, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.j4l('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', cause);
        captureStack($this, $this.b5v_1);
        $this.z5u_1 = url;
        $this.a5v_1 = timeoutMillis;
        return $this;
      }
      static d5v(request) {
        var tmp = request.h5l_1.f5a();
        var tmp0_safe_receiver = request.e5v(HttpTimeoutCapability_instance);
        return this.c5v(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i5v());
      }
      g14() {
        return HttpRequestTimeoutException().c5v(this.z5u_1, this.a5v_1, this.cause);
      }
    }
    initMetadataForClass($, 'HttpRequestTimeoutException', VOID, VOID, [CopyableThrowable()]);
    HttpRequestTimeoutExceptionClass = $;
  }
  return HttpRequestTimeoutExceptionClass;
}
function checkTimeoutValue($this, value) {
  // Inline function 'kotlin.require' call
  if (!(value == null || value > 0n)) {
    var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeoutConfig.INFINITE_TIMEOUT_MS';
    throw IllegalArgumentException().o2(toString(message));
  }
  return value;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.j5v_1 = 9223372036854775807n;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'TimeoutConfiguration';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpTimeoutConfig());
        var tmp_1 = null instanceof HttpTimeoutConfig();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(getKClass(HttpTimeoutConfig()), arrayOf([]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
        tmp.k5v_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function init_io_ktor_client_plugins_HttpTimeoutConfig(_this__u8e3s4) {
  Companion_getInstance_0();
  _this__u8e3s4.f5v_1 = 0n;
  _this__u8e3s4.g5v_1 = 0n;
  _this__u8e3s4.h5v_1 = 0n;
}
var HttpTimeoutConfigClass;
function HttpTimeoutConfig() {
  if (HttpTimeoutConfigClass === VOID) {
    class $ {
      static l5v(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
        Companion_getInstance_0();
        requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
        connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
        socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
        var $this = createThis(this);
        init_io_ktor_client_plugins_HttpTimeoutConfig($this);
        $this.m5v(requestTimeoutMillis);
        $this.n5v(connectTimeoutMillis);
        $this.o5v(socketTimeoutMillis);
        return $this;
      }
      m5v(value) {
        this.f5v_1 = checkTimeoutValue(this, value);
      }
      i5v() {
        return this.f5v_1;
      }
      n5v(value) {
        this.g5v_1 = checkTimeoutValue(this, value);
      }
      p5v() {
        return this.g5v_1;
      }
      o5v(value) {
        this.h5v_1 = checkTimeoutValue(this, value);
      }
      q5v() {
        return this.h5v_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof HttpTimeoutConfig()))
          THROW_CCE();
        if (!(this.f5v_1 == other.f5v_1))
          return false;
        if (!(this.g5v_1 == other.g5v_1))
          return false;
        if (!(this.h5v_1 == other.h5v_1))
          return false;
        return true;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.f5v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.g5v_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        result = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_1 = this.h5v_1;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
        result = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'HttpTimeoutConfig', $.l5v);
    HttpTimeoutConfigClass = $;
  }
  return HttpTimeoutConfigClass;
}
function get_supportsRequestTimeout(_this__u8e3s4) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var tmp;
  var tmp_0;
  if (!isWebsocket(_this__u8e3s4.h5l_1.v58())) {
    var tmp_1 = _this__u8e3s4.k5l_1;
    tmp_0 = !(tmp_1 instanceof ClientUpgradeContent());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_2 = _this__u8e3s4.k5l_1;
    tmp = !(tmp_2 instanceof SSEClientContent());
  } else {
    tmp = false;
  }
  return tmp;
}
function applyRequestTimeout(_this__u8e3s4, request, requestTimeout) {
  _init_properties_HttpTimeout_kt__pucqrr();
  if (requestTimeout == null || requestTimeout === 9223372036854775807n)
    return Unit_instance;
  var executionContext = request.l5l_1;
  var tmp = new (CoroutineName())('request-timeout');
  var killer = launch(_this__u8e3s4, tmp, VOID, applyRequestTimeout$slambda(requestTimeout, request, executionContext));
  var tmp_0 = request.l5l_1;
  tmp_0.zx((it) => {
    killer.hy();
    return Unit_instance;
  });
}
function HttpTimeoutConfig$_init_$ref_dl1k0m() {
  return constructCallableReference(() => HttpTimeoutConfig().l5v(), 0, 0, 223);
}
function HttpTimeout$lambda($this$createClientPlugin) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var requestTimeoutMillis = $this$createClientPlugin.b5q_1.i5v();
  var connectTimeoutMillis = $this$createClientPlugin.b5q_1.p5v();
  var socketTimeoutMillis = $this$createClientPlugin.b5q_1.q5v();
  var tmp = Send_instance;
  $this$createClientPlugin.e5q(tmp, HttpTimeout$lambda$slambda(connectTimeoutMillis, socketTimeoutMillis, requestTimeoutMillis));
  return Unit_instance;
}
function invoke$hasNotNullTimeouts(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, supportsRequestTimeout) {
  return supportsRequestTimeout && !(requestTimeoutMillis == null) || !(connectTimeoutMillis == null) || !(socketTimeoutMillis == null);
}
function HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var supportsRequestTimeout = get_supportsRequestTimeout(request);
    var configuration = request.e5v(HttpTimeoutCapability_instance);
    var tmp;
    if (configuration == null && invoke$hasNotNullTimeouts($requestTimeoutMillis, $connectTimeoutMillis, $socketTimeoutMillis, supportsRequestTimeout)) {
      configuration = HttpTimeoutConfig().l5v();
      request.r5v(HttpTimeoutCapability_instance, configuration);
      tmp = Unit_instance;
    }
    var tmp0_safe_receiver = configuration;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      var tmp0_elvis_lhs = tmp0_safe_receiver.p5v();
      tmp0_safe_receiver.n5v(tmp0_elvis_lhs == null ? $connectTimeoutMillis : tmp0_elvis_lhs);
      var tmp1_elvis_lhs = tmp0_safe_receiver.q5v();
      tmp0_safe_receiver.o5v(tmp1_elvis_lhs == null ? $socketTimeoutMillis : tmp1_elvis_lhs);
      if (supportsRequestTimeout) {
        var tmp2_elvis_lhs = tmp0_safe_receiver.i5v();
        tmp0_safe_receiver.m5v(tmp2_elvis_lhs == null ? $requestTimeoutMillis : tmp2_elvis_lhs);
        applyRequestTimeout($this$on, request, tmp0_safe_receiver.i5v());
      }
    }
    return yield* $this$on.i5s(request, $completion);
  }), 2);
}
function applyRequestTimeout$slambda($requestTimeout, $request, $executionContext) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    Companion_getInstance();
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = $requestTimeout;
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var cause = HttpRequestTimeoutException().d5v($request);
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$2 = 'Request timeout: ' + $request.h5l_1.toString();
      this_1.b4x(tmp$ret$2);
    }
    cancel($executionContext, ensureNotNull(cause.message), cause);
    return Unit_instance;
  }), 1);
}
var properties_initialized_HttpTimeout_kt_9oyjbd;
function _init_properties_HttpTimeout_kt__pucqrr() {
  if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
    properties_initialized_HttpTimeout_kt_9oyjbd = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    var tmp = HttpTimeoutConfig$_init_$ref_dl1k0m();
    HttpTimeout = createClientPlugin('HttpTimeout', tmp, HttpTimeout$lambda);
  }
}
//region block: init
HttpTimeoutCapability_instance = new (HttpTimeoutCapability())();
//endregion
//region block: exports
export {
  HttpTimeoutCapability_instance as HttpTimeoutCapability_instance202wzu4l72tz3,
  HttpRequestTimeoutException as HttpRequestTimeoutException19335ch7q7rkf,
  get_HttpTimeout as get_HttpTimeout3mcrbvfnvmyx2,
};
//endregion

//# sourceMappingURL=HttpTimeout.mjs.map
